module.exports = __webpack_public_path__ + "assets/img/o5.31244e4d.png";